export default __webpack_public_path__ + "b1c753fc52ba843f8c5b0f0539dc4629.png";